import { Collapsible, CollapsibleContent } from '@heidi/design-system/collapsible';
import { cn } from '@heidi/utils';
import type { ReactNode } from 'react';

/** The press on every Working toggle: the other half of what opening a row feels like. */
export const WORKING_TOGGLE_PRESS =
  'transition-transform ease-out-quart [transition-duration:120ms] active:scale-[0.98] motion-reduce:transform-none motion-reduce:transition-none';

/** The design system's collapsible motion, as `collapsible-card` uses it. */
const WORKING_FOLD =
  'overflow-hidden motion-safe:data-[state=closed]:animate-collapsible-up motion-safe:data-[state=open]:animate-collapsible-down';

export interface WorkingDisclosureProps {
  id?: string;
  open: boolean;
  children: ReactNode;
  /** Applied inside the fold; spacing goes here so it folds away with the rows. */
  className?: string;
  'data-testid'?: string;
}

/**
 * The content of a Working disclosure, on the design system's collapsible. It
 * folds with the shared `collapsible-down`/`collapsible-up` keyframes and is
 * unmounted once shut, so a long thread holds no closed rows. The open keyframe
 * does not fill forwards (#22432): once open, the height is `auto` again, so
 * rows that arrive while it is open are never clipped.
 */
export const WorkingDisclosure = ({
  id,
  open,
  children,
  className,
  'data-testid': testId,
}: WorkingDisclosureProps) => (
  <Collapsible open={open}>
    <CollapsibleContent id={id} data-testid={testId} className={WORKING_FOLD}>
      <div className={cn('min-w-0', className)}>{children}</div>
    </CollapsibleContent>
  </Collapsible>
);
